import { debug } from './logger';
export async function detectMimeType(url, format) {
    if (format && format !== 'pls') {
        debug(`Using format to detect mime type: ${format}`);
        const determinedFormat = formatToMimeType(format);
        if (determinedFormat) {
            return determinedFormat;
        }
    }
    const extensionMimeType = readExtension(url);
    if (extensionMimeType) {
        return extensionMimeType;
    }
    const contentType = await getContentTypeHeader(url);
    if (contentType) {
        return contentType;
    }
    const magicMimeType = await readMagicNumberBytes(url);
    if (magicMimeType) {
        return magicMimeType;
    }
    return 'unknown';
}
export function formatToMimeType(format) {
    switch (format) {
        case 'aac':
            return 'audio/aac';
        case 'flac':
            return 'audio/flac';
        case 'mp3':
            return 'audio/mpeg';
        case 'ogv':
            return 'video/ogg';
        case 'opus':
        case 'ogg':
            return 'audio/ogg';
        case 'mediatailor':
        case 'hls':
        case 'm3u8':
            return 'application/vnd.apple.mpegurl';
        case 'wav':
            return 'audio/wav';
        case 'weba':
            return 'audio/weba';
        case 'webm':
            return 'video/webm';
        default:
            return;
    }
}
function readExtension(url) {
    const { pathname } = new URL(url);
    const ext = pathname.split('.').pop();
    debug(`Ext: ${ext}`);
    return formatToMimeType(ext);
}
async function getContentTypeHeader(url) {
    try {
        const result = await fetch(url, { method: 'HEAD' });
        const contentType = result.headers.get('Content-Type')?.split(';')[0];
        debug(`Content-Type: ${contentType}`);
        return contentType;
    }
    catch {
    }
}
async function readMagicNumberBytes(url) {
    try {
        const response = await fetch(url);
        if (response.body) {
            const reader = response.body.getReader();
            const result = await reader.read();
            const format = getAudioTypeFromBuffer(result.value);
            if (format) {
                return formatToMimeType(format);
            }
        }
    }
    catch {
    }
}
const hexMap = {
    '494433': 'mp3',
    fffb9: 'mp3',
    fffa9: 'mp3',
    '664c614300000022': 'flac',
    fff1: 'aac',
    fff9: 'aac',
    '4f67675300020000000000000000': 'ogg',
    '57415645666d7420': 'wav',
    '1a45dfa3': 'webm',
};
function buf2hex(buffer) {
    return Array.prototype.map
        .call(new Uint8Array(buffer), x => `00${x.toString(16)}`.slice(-2))
        .join('');
}
function getAudioTypeFromBuffer(buffer) {
    if (!buffer) {
        return;
    }
    const hex = buf2hex(buffer);
    debug(`File hex: ${hex.slice(0, 32)}`);
    for (const sig in hexMap) {
        if (hex.indexOf(sig) === 0) {
            return hexMap[sig];
        }
    }
}
